function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDetailedClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "clock-icon",
    d: "M8 16a8 8 0 1 1 8-8 8.009 8.009 0 0 1-8 8zM8 1.333A6.667 6.667 0 1 0 14.667 8 6.674 6.674 0 0 0 8 1.333zM11.333 8a.666.666 0 0 0-.667-.667h-2V4a.667.667 0 0 0-1.333 0v4A.666.666 0 0 0 8 8.667h2.667A.666.666 0 0 0 11.333 8z",
    style: {
      fill: "#0F1177"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailedClockIcon);
export default __webpack_public_path__ + "static/media/detailed-clock-icon.d7c325eb179ff2cfa69eee849dd5bdf0.svg";
export { ForwardRef as ReactComponent };